import styled, { css } from 'styled-components';

// ---------------------------------------------------------------------------
// Shared
// ---------------------------------------------------------------------------

export const SContentWrapper = styled.div`
  padding: 16px 24px;
`;

export const SHeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 12px;
`;

export const SHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

// ---------------------------------------------------------------------------
// YearSummary
// ---------------------------------------------------------------------------

export const SYtdBanner = styled.div`
  background: #f0f5ff;
  border: 1px solid #d6e4ff;
  border-radius: 8px;
  padding: 20px 24px;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SQuarterGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 24px;
`;

export const SQuarterTile = styled.button<{ $hasData: boolean }>`
  font-family: 'Lato', sans-serif;
  background: ${({ $hasData }) => ($hasData ? '#fff' : '#fafafa')};
  border: 1px solid ${({ $hasData }) => ($hasData ? '#d9d9d9' : '#f0f0f0')};
  border-radius: 8px;
  padding: 16px;
  cursor: ${({ $hasData }) => ($hasData ? 'pointer' : 'default')};
  transition: all 0.2s ease;
  text-align: left;
`;

export const SEmptyWrapper = styled.div`
  padding: 64px 24px;
  text-align: center;
`;

// ---------------------------------------------------------------------------
// QuarterDetail
// ---------------------------------------------------------------------------

export const SBreadcrumbWrapper = styled.div`
  margin-bottom: 16px;
`;

export const SStatsRow = styled.div`
  display: flex;
  gap: 24px;
  margin-bottom: 24px;
  flex-wrap: wrap;
`;

const statBoxBase = css`
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 12px 20px;
  min-width: 140px;
`;

export const SStatBox = styled.div`
  ${statBoxBase}
`;

export const SCategoryCollapse = styled.div`
  .ant-collapse-content-box {
    padding: 0 !important;
  }
`;

export const SCollapseLabelRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-right: 8px;
`;

export const SCollapseLabelLeft = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;

export const SDeleteRecordInfo = styled.div`
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 6px;
  padding: 12px;
  margin-top: 8px;
`;

export const SBreadcrumbLink = styled.span`
  color: ${({ theme }) => theme.colorPrimaryDefault};
  cursor: pointer;
`;
